export async function getTimezoneFromCoordinates(
    latitude: number,
    longitude: number,
): Promise<string | undefined> {
    const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? "";

    const myParams = {
        location: `${latitude},${longitude}`,
        timestamp: Math.floor(Date.now() / 1000).toString(),
        key: apiKey,
    };

    const u = new URLSearchParams(myParams).toString();
    const apiUrl = `https://maps.googleapis.com/maps/api/timezone/json?${u}`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data.status === "OK") {
            const timezoneName = data.timeZoneId;
            return timezoneName;
        } else {
            console.error("Failed to retrieve timezone data:", data.status);
            return undefined;
        }
    } catch (error) {
        console.error("Error fetching timezone data:", error);
        return undefined;
    }
}
